export function getSavedTheme() {
  try {
    return localStorage.getItem('user-theme') === 'light' ? 'light' : 'dark'
  } catch (_) {
    return 'dark'
  }
}

export function applyTheme(theme) {
  const value = theme === 'light' ? 'light' : 'dark'
  document.documentElement.dataset.theme = value
  try {
    localStorage.setItem('user-theme', value)
  } catch (_) {
    // Theme switching still works when storage is unavailable.
  }
}
